import { z } from "zod";

export const addLiabilitySchema = z.object({
    idUUID: z.string().nullable().optional(),
    idCaseID: z.string().nullable().optional(),
    idRoleID: z.string().nullable().optional(),
    claimNumber: z.string().nullable(),
    idCompanyID: z.string().nullable(),
    idAdjuster: z.string().optional().default(""),
    policyPersonCoverageMM: z.string().nullable().optional(),
    policyVehiculeCoverageMM: z.string().nullable().optional(),
    policyInsuredName: z.string().min(1, "Insured name is required"),
    policyDriverName: z.string().nullable().optional(),
    formLimits: z.string().nullable().optional(),

    // person information
    namePrefix: z.string().optional().nullable(),
    nameFirst: z.string().optional().nullable().default(""),
    nameI: z.string().optional().nullable(),
    nameLast: z.string().optional().nullable().default(""),
    nameSuffix: z.string().optional().nullable(),
    nameAKA: z.string().optional().nullable(),
    address: z.string().optional().nullable(),
    address2: z.string().optional().nullable(),
    city: z.string().optional().nullable(),
    state: z.string().optional().nullable(),
    zip: z.string().optional().nullable(),
    phoneNumber: z.string().optional().nullable(),
    phoneExtension: z.string().optional().nullable(),
    faxNumber: z.string().optional().nullable(),
    email: z.string().optional().nullable(),
});
